import React from 'react';
import { Link } from 'react-router-dom';

export default function ApWordmark({ compact = false, to = '/' }) {
  return (
    <Link className={`ap-wordmark ${compact ? 'is-compact' : ''}`} to={to} aria-label="APDoneRight home">
      <span className="ap-wordmark-mark" aria-hidden="true">
        <svg viewBox="0 0 48 48" fill="none">
          <path d="M24 2.5 27.2 20.8 45.5 24 27.2 27.2 24 45.5 20.8 27.2 2.5 24 20.8 20.8 24 2.5Z" fill="currentColor" />
          <path d="M24 8.5V39.5M8.5 24H39.5" stroke="currentColor" strokeWidth="1" />
        </svg>
      </span>
      <span>APDoneRight</span>
    </Link>
  );
}
